export function useLoadingCheck() {
  const loading = document.querySelector('#loading-app')
  if (loading) {
    const app = document.querySelector('#app-inner')
    setTimeout(() => {
      app?.removeChild(loading)
    }, 100)
  }
}

export function useScrollToTop() {
  const app = document.getElementById('app')
  if (app) {
    setTimeout(() => {
      app.scrollTo({
        top: 0,
      })
    }, 300)
  }
}
